import styled from "styled-components";
import { devices } from "../../utilities/responsive";

export const Footer = styled.footer<{ dark: boolean }>`
  padding: 10rem 8vw 3rem 4vw;
  margin-top: auto;

  .linkedInIcon svg {
    rect {
      fill: ${(props) => (props.dark ? "white" : "#0077b5")};
    }

    path {
      fill: ${(props) => (props.dark ? "#0077b5" : "white")};
      stroke: ${(props) => (props.dark ? "#0077b5" : "white")};
    }

    circle {
      fill: ${(props) => (props.dark ? "#0077b5" : "white")};
    }
  }

  .facebookIcon svg {
    rect {
      fill: ${(props) => (props.dark ? "white" : "#0077b5")};
    }

    path {
      fill: ${(props) => (props.dark ? "#4267B2" : "white")};
    }
  }

  ul {
    display: inline-flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
    margin: 0 auto;
    padding-bottom: 0%;

    li {
      display: flex;
      align-items: flex-start;
      font-family: "Nunito Sans", sans-serif;
      letter-spacing: 0.9px;
      white-space: pre-wrap;
      color: ${(props) => (props.dark ? "#f3f3f3" : "#585fa6")};
      font-weight: 400;
      font-size: 16px;
      letter-spacing: 0.09px;
      line-height: 1.4;
      padding-left: 0;

      &:not(:last-child) {
        margin-right: 30px;
      }

      &.footer__contacts {
        display: flex;
        flex-direction: column;
        gap: 8px;
      }
      .footer__socials {
        display: flex;

        @media (min-width: 768px) {
          margin-top: 5px;
          .icon:not(:first-of-type) {
            margin-left: 10px;
          }
          .instagramIcon {
            margin-top: 2px;
          }
        }
      }

      .genderEqualityCertification,
      .pdfCertiquality,
      .openApiLogo {
        width: 120px;
      }

      i {
        display: flex;
        align-items: center;

        a {
          display: flex;
          align-items: center;
          font-size: 1.6rem;
          color: #f3f3f3;

          @media (max-width: 767.9px) {
            font-size: 1.8rem;
          }
        }
      }
      .footer__odooLogoGold {
        width: 160px;
        height: 100%;
      }

      .footer__certiqalityLogoGold img {
        width: 230px;
      }

      @media ${devices.tabletPortrait} {
        margin-bottom: 1rem;
      }

      .icon {
        svg,
        img {
          height: 1.8rem;
          width: 1.8rem;
          fill: #f3f3f3;
        }
      }

      .listData {
        display: inline-flex;
        flex-wrap: wrap;
        flex-direction: column;
      }

      @media (min-width: 768px) {
        &:not(:first-child):before {
          margin-right: 0px;
        }
        &:has(.footer__odooLogoGold):before {
          display: none;
        }
        &:has(.footer__certiqalityLogoGold):before {
          display: none;
        }
        .footer__certiqalityLogoGold,
        .footer__odooLogoGold {
          margin-top: 10px;
        }

        .listData > a {
          color: var(--green);
          font-size: 2rem;
          color: #c5e28c;
          font-weight: 600;
          letter-spacing: 2px;
        }
      }

      @media (max-width: 767.9px) {
        .listData > a {
          width: 100%;
          font-size: 2rem;
          color: var(--green);
        }

        .icon {
          margin-right: 1rem;
          margin-top: 1.5rem;
          svg,
          img {
            width: 2.4rem;
            height: 2.4rem;
          }
        }
        .footer__odooLogoGold {
          width: 230px;
        }

        .footer__certiqalityLogoGold img {
          width: 230px;
        }
      }

      @media (max-width: 768px) {
        width: 100%;
      }

      a:hover {
        color: var(--primary-on-hover) !important;
      }
    }
  }

  .footer-separator {
    img {
      width: 100%;
    }
  }
`;
